// extracted by mini-css-extract-plugin
export default {"common-setting-container":"styles_common-setting-container__V2V6v","idContainer":"styles_idContainer__FW2Cd"};